module.exports = __webpack_public_path__ + "img/Edit.f0a1796c.svg";